module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "cover"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "dedication"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter-1",
    attrs: {
      "id": "Ref_19961a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19964a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19967a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19970a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter004"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19973a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter005"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19976a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter006"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19979a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19982a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19986a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19989a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19992a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19995a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_19999a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20002a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20005a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20008a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20011a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20014a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20017a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20020a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20023a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20026a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20029a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20032a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20035a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20038a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20041a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20044a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20047a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20050a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20053a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20057a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20060a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20063a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20066a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20069a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20072a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20075a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20079a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20082a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20085a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20088a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20091a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20094a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20097a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20100a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20103a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20106a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20109a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 49")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20112a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 50")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20115a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 51")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20118a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 52")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20121a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 53")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20124a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 54")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20127a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 55")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20130a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 56")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20133a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 57")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20136a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 58")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20139a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 59")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20142a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 60")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20145a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 61")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20148a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 62")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20151a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 63")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20154a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 64")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20157a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 65")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20160a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 66")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20163a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 67")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20166a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 68")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20169a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 69")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20172a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 70")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20175a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 71")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_20178a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 72")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter-1",
    attrs: {
      "id": "toc-discover-page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/discoverpage"
    }
  }, [_vm._v("Discover More")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "id_1_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/extras",
      "id": "Ref_45814a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Extras")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapteri",
    attrs: {
      "id": "id_1_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "id": "Ref_45817a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapteri",
    attrs: {
      "id": "id_1_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix002",
      "id": "Ref_45820a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Preview of "), _c('em', [_vm._v("A Big Ship at the Edge of the Universe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapteri",
    attrs: {
      "id": "id_1_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix003",
      "id": "Ref_45823a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Preview of "), _c('em', [_vm._v("The Corporation Wars: Dissidence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "id_1_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/adcard",
      "id": "Ref_45808a"
    }
  }, [_vm._v("By Rob Boffard")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0